<template>
  <div class="gh-home-testimonials">
    <gh-testimonial-sliders 
      ref="slider" 
      :items="items" 
      :options="sliderOptions" 
      :autoplay="autoplay">
      <template #default="{ item }">
        <gh-testimonial-grid-item  
          :testimonial="item"  
          :show-individule-button="true" 
          class="v-testimonial" 
          @openFullBio="openFullBio" 
          custom-class="gh-home-dialog-testimonial" />
      </template>
    </gh-testimonial-sliders>
  </div>
</template>

<script>
export default {
  name: "HomeTestimonials",

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  components: {
    ghTestimonialSliders: () => 
      import(/* webpackChunkName: "testimonial" */ "@/modules/testimonial/components/TestimonialSliders.vue"),
    ghTestimonialGridItem: () => 
      import(/* webpackChunkName: "testimonial" */ "@/modules/testimonial/components/TestimonialGridItem.vue"),
  },

  data() {
    return {
      autoplay: {
        delay: 3000, // Default autoplay delay
        disableOnInteraction: true,
      },
      sliderOptions: {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1112: {
            slidesPerView: 3,
          },
          1500: {
            slidesPerView: 4,
          },
          1920: {
            slidesPerView: 4.7,
            spaceBetween: 35,
            centeredSlides: true,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },

  methods: {
    openFullBio(value) {
      if (value) {
        this.autoplay = false;
      } else {
        this.autoplay = {
          delay: 3000,
        };
      }
    },
  },
};
</script>

